import { Badge, Group, NavLink } from '@mantine/core';
import { type ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useUiStore } from '../store/uiStore';
import { NAV_ITEMS } from './navItems';

/** Menú lateral de navegación del panel. */
export function SideMenu(): ReactNode {
  const location = useLocation();
  const setNavbar = useUiStore((s) => s.setNavbar);

  return (
    <>
      {NAV_ITEMS.map((item) => {
        const Icon = item.icon;
        const active = location.pathname === item.to;
        return (
          <NavLink
            key={item.to}
            component={Link}
            to={item.to}
            active={active}
            aria-current={active ? 'page' : undefined}
            data-agent-id={item.agentId}
            label={item.label}
            leftSection={<Icon size={18} stroke={1.6} />}
            rightSection={
              item.comingSoon ? (
                <Badge size="xs" variant="light" color="gray">
                  pronto
                </Badge>
              ) : undefined
            }
            onClick={() => setNavbar(false)}
          />
        );
      })}
      <Group justify="center" mt="auto" />
    </>
  );
}
